<mat-form-field class="mt-4 w-100">
    <mat-label class="form-label">Amount to give away</mat-label>
    <input type="number" [(ngModel)]="amount" matInput>
</mat-form-field>
<app-leaderboard-page (actionEvent)="action($event)" [actionType]="actionType" [changeValue]='changeValue'></app-leaderboard-page>